// SALES-032: ONE shared, display-only phone formatter for the Leads page.
// Stored values are never rewritten; the server's digit-only matching is untouched.
//
// formatPhone(raw):
//   - 10 digits, or 11 digits starting with 1 (once non-digits are removed):
//     show "(647) 996-2121"
//   - anything else (international, too few digits, text): show exactly as stored
//
// telHref(raw):
//   - North American number: "tel:+1" + the 10 digits
//   - otherwise: "tel:" + the "+" (if present) and the stored digits; "" when there
//     are no digits at all (the caller then renders plain text, not a link)

function naTenDigits(raw) {
  const digits = String(raw ?? "").replace(/\D/g, "");
  if (digits.length === 10) return digits;
  if (digits.length === 11 && digits[0] === "1") return digits.slice(1);
  return null;
}

export function formatPhone(raw) {
  if (raw == null) return "";
  const s = String(raw);
  const ten = naTenDigits(s);
  if (!ten) return s; // international / too few digits / text → unchanged
  return `(${ten.slice(0, 3)}) ${ten.slice(3, 6)}-${ten.slice(6)}`;
}

export function telHref(raw) {
  if (raw == null) return "";
  const s = String(raw);
  const ten = naTenDigits(s);
  if (ten) return `tel:+1${ten}`;
  const digits = s.replace(/\D/g, "");
  if (!digits) return ""; // nothing dialable (e.g. a text value) → no link
  const plus = s.trim().startsWith("+") ? "+" : "";
  return `tel:${plus}${digits}`;
}
